import path from 'node:path'
import type { DeployEnvVar } from '@cli-types/next-adapter/vercel.js'
import { VERCEL_ENV_SYNC_SKIP_KEYS } from '@cli-constants/env-sync.js'
import { parseDotenvFile } from '@cli-utils/files.js'
import { isPlaceholderValue } from '@next-adapter/init/scaffolders/env/is-placeholder-value.js'

export function collectDeployEnvVars(
  cwd: string,
  existingProductionKeys: Set<string>
): DeployEnvVar[] {
  const local = parseDotenvFile(path.join(cwd, '.env.local'))
  const vars: DeployEnvVar[] = []

  for (const [key, value] of local) {
    if (VERCEL_ENV_SYNC_SKIP_KEYS.has(key)) continue
    if (!value || isPlaceholderValue(value)) continue
    if (existingProductionKeys.has(key)) continue
    vars.push({ key, value })
  }

  return vars
}
